import ReactDOM from 'react-dom';
import {MODAL_ROOT_ID} from '../../index';

const ModalPortal = ({children}) => {
  return ReactDOM.createPortal(
    children,
    document.getElementById(MODAL_ROOT_ID),
  );
};

export default ModalPortal
